import { Injectable } from '@angular/core';


@Injectable()
export class StorageService {

  constructor() {
  }
    public saveUser(user: any) {
        localStorage.setItem('currentUser', JSON.stringify(user));
    }
    public saveAuthenticate(authenticate: any) {
        localStorage.setItem('authentication', JSON.stringify(authenticate));
    }

    public async getAuthenticate() {
        try {
            return JSON.parse(localStorage.getItem('authentication'));
        } catch (e) {
            localStorage.clear();
            return null;
        }
    }

    public getAuthenticatedUser() {
        if (localStorage.getItem('currentUser')) {
            return JSON.parse(localStorage.getItem('currentUser'));
        }
    }

    public getAuthenticationTokenClear() {
        localStorage.clear();
        sessionStorage.clear();
    }

}
